module.exports = __webpack_public_path__ + "bg-agua-mobile.67e934bd26468c69f6ce.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/images/bg-agua-mobile.jpg
// module id = ../../../../../src/assets/images/bg-agua-mobile.jpg
// module chunks = styles